package co.maytes.standupbot.dashboard.components.feedback

import androidx.compose.runtime.Composable
import co.maytes.standupbot.dashboard.lib.api.ApiError

/**
 * Picks the right visual for an [ApiError]:
 *  - 404 → full-page [NotFoundScreen]
 *  - 401 → session-expired [NotFoundScreen] variant
 *  - anything else → inline [ErrorState] card with Retry
 *
 * Use when rendering a failed resource fetch at the page level. Inline-only
 * failures (a button action, a modal save) should keep using toasts instead.
 */
@Composable
fun ApiErrorView(
    error: ApiError,
    resourceLabel: String,
    onRetry: () -> Unit,
    onBack: (() -> Unit)? = null,
) {
    when {
        error is ApiError.Http && error.status == NOT_FOUND ->
            NotFoundScreen(
                title = "$resourceLabel not found",
                message = error.detail
                    ?: "This $resourceLabel doesn't exist or you don't have access.",
                primaryLabel = onBack?.let { "Go back" },
                onPrimary = onBack,
            )
        error is ApiError.Http && error.status == UNAUTHORIZED ||
            error is ApiError.Unauthorized ->
            NotFoundScreen(
                title = "Session expired",
                message = "Sign in again to continue.",
                primaryLabel = null,
                onPrimary = null,
            )
        else ->
            ErrorState(
                title = "Failed to load $resourceLabel",
                message = error.displayMessage,
                onRetry = onRetry,
            )
    }
}

private const val NOT_FOUND = 404
private const val UNAUTHORIZED = 401
